import { animation, animate, style } from '@angular/animations';

export namespace AnimationLib {

  export const slideTransition = animation([
    style({
      transform: `translateY({{ from }}%)`,
      opacity: 0
    }),
    animate(`{{ duration }}ms ease-out`, style({
      transform: `translateY({{ to }})`,
      opacity: 1
    }))
  ]);

}
